import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { DashboardContentLayout } from '~ui-components/components/atoms/dashboard-content-layout';

interface Slots {
	Content: React.ElementType;
}

const Empty = () => null;

const defaultSlots: Slots = {
	Content: Empty,
};

interface Props {
	slots?: Slots;
}

function Layers(props: Props) {
	// const router = useRouter();

	return (
		<DashboardContentLayout
			pageTitle="Layers"
			// actionButtonProps={{
			// 	children: 'Add layer',
			// 	component: RouterLink,
			// 	variant: 'contained',
			// 	href: paths.accountName.maps.mapId.mapName.addLayer(
			// 		router.query['account-name'],
			// 		router.query['map-id'],
			// 		router.query['map-name']
			// 	),
			// }}
		>
			<Root {...props} />
		</DashboardContentLayout>
	);
}

function Root(props: Props) {
	const { slots = {} } = props;

	const Slots = {
		...defaultSlots,
		...slots,
	};

	return (
		<Stack
			direction={{ xs: 'column', md: 'row' }}
			spacing={4}
			sx={{ position: 'relative' }}
		>
			{/* <LayersSideNav /> */}
			<Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
				<Slots.Content />
			</Box>
		</Stack>
	);
}

export { Layers };
